import { TGetEyeconJackpotsResponse } from '@interlayer/js/components/common/Jackpot/buzz/types';
import { TFetchGamesGlobalJackpotProps } from '@interlayer/js/components/common/Jackpot/store/types';

import { actionTypes } from './constants';

type Action<T extends actionTypes, P> = {
    type: T;
    payload: P;
};

export const fetchEyeconJackpot = (payload: TGetEyeconJackpotsResponse): Action<
    actionTypes.SET_JACKPOTS_EYECON_FETCH,
    TGetEyeconJackpotsResponse
> => ({
    type: actionTypes.SET_JACKPOTS_EYECON_FETCH,
    payload
});

export const fetchGamesGlobalJackpot = (payload: TFetchGamesGlobalJackpotProps): Action<
    actionTypes.SET_JACKPOTS_GAMES_GLOBAL_FETCH,
    TFetchGamesGlobalJackpotProps
> => ({
    type: actionTypes.SET_JACKPOTS_GAMES_GLOBAL_FETCH,
    payload
});
